export default __webpack_public_path__ + "static/media/Assurant.67593f3f.svg";